import React from 'react';
import styled from 'styled-components';

import { NavigationLink } from '../types/navigationLink';
import Button from './Button';
import { ButtonProps } from '../types/button';
import { SPACING_GAP_MAP, GapSize } from '../constants/sizes';

const LinkStyles = styled.ul<{ $vertical: boolean; $gap: GapSize }>`
  display: flex;
  flex-direction: ${({ $vertical }: { $vertical: boolean }) => ($vertical ? 'column' : 'row')};
  gap: ${({ $gap }: { $gap: GapSize }) => SPACING_GAP_MAP[$gap]};
`;

interface LinkProps {
  links: NavigationLink[];
  vertical?: boolean;
  gap?: GapSize;
  buttonStyles?: ButtonProps;
  onClick?: () => void;
  children?: React.ReactNode;
  target?: string;
  rel?: string;
}

const Links: React.FC<LinkProps> = ({
  links,
  vertical = false,
  gap = 'base',
  buttonStyles,
  onClick,
  children,
  target,
  rel,
}) => {
  return (
    <LinkStyles $vertical={vertical} $gap={gap}>
      {links.map(
        ({
          label,
          to,
          ariaLabel,
          iconName,
          iconColour,
          iconPosition,
          rel: linkRel,
          showExternalLinkArrowIcon,
          target: linkTarget,
        }) => (
          <li key={`${to} li`}>
            <Button
              {...buttonStyles}
              href={to}
              text={label}
              ariaLabel={ariaLabel}
              onClick={onClick}
              iconName={iconName || buttonStyles?.iconName}
              iconColour={iconColour || buttonStyles?.iconColour}
              iconPosition={iconPosition || buttonStyles?.iconPosition}
              target={linkTarget || target}
              rel={linkRel || rel}
              showExternalLinkArrowIcon={
                showExternalLinkArrowIcon ?? buttonStyles?.showExternalLinkArrowIcon
              }
            />
          </li>
        )
      )}
      {children}
    </LinkStyles>
  );
};

export default Links;
